(function () {
  'use strict';
  var dataEl = document.getElementById('kz-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var T = D.t || {};
  var V = D.v || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || D.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cartState = null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(D.intl || 'fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function req(path, body) {
    var opts = { method: body ? 'POST' : 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(ROOT + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j && (j.description || j.message) || 'cart'); err.data = j; throw err; } return j; });
    });
  }

  function qtyOf(cart, id) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (it.variant_id === id) n += it.quantity; });
    return n;
  }

  function wantedGifts(straps) {
    return { ebook: straps >= 2 ? 1 : 0, masseur: straps >= 4 ? 1 : 0 };
  }

  function normalize(cart) {
    var straps = qtyOf(cart, V.strap);
    var want = wantedGifts(straps);
    var updates = {};
    var need = false;
    if (V.ebook && qtyOf(cart, V.ebook) !== want.ebook) { updates[V.ebook] = want.ebook; need = true; }
    if (V.masseur && qtyOf(cart, V.masseur) !== want.masseur) { updates[V.masseur] = want.masseur; need = true; }
    if (!need) return Promise.resolve(cart);
    return req('cart/update.js', { updates: updates }).then(function (c) { return c; });
  }

  function refresh() {
    return req('cart.js').then(normalize).then(function (c) { cartState = c; render(c); return c; });
  }

  var drawer = $('[data-kz-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('kz-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); var p = $('.kz-drawer__panel', drawer); if (p) p.focus(); });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('kz-lock');
    setTimeout(function () { drawer.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var ICON_TRASH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
  var ICON_HEAT = '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><rect x="6" y="14" width="36" height="22" rx="11" fill="#171717"/><rect x="14" y="20" width="20" height="10" rx="5" fill="#ff7a45"/></svg>';
  var ICON_BOOK = '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M8 9h14a4 4 0 0 1 4 4v27a3 3 0 0 0-3-3H8z" fill="#171717"/><path d="M40 9H28a2 2 0 0 0-2 2v29a3 3 0 0 1 3-3h11z" fill="#3b3b3b"/></svg>';

  function render(cart) {
    var count = $$('[data-kz-cart-count]');
    count.forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var lines = $('[data-kz-lines]', drawer);
    var empty = $('[data-kz-empty]', drawer);
    var foot = $('[data-kz-foot]', drawer);
    var upsell = $('[data-kz-upsell]', drawer);
    var items = cart.items || [];
    var cur = cart.currency;
    if (!items.length) {
      lines.innerHTML = '';
      empty.hidden = false; foot.hidden = true; upsell.hidden = true;
      return;
    }
    empty.hidden = true; foot.hidden = false;
    var ordered = items.slice().sort(function (a, b) {
      var w = function (it) { return it.variant_id === V.strap ? 0 : it.variant_id === V.masseur ? 1 : it.variant_id === V.ebook ? 2 : 3; };
      return w(a) - w(b);
    });
    lines.innerHTML = ordered.map(function (it) {
      var isStrap = it.variant_id === V.strap;
      var isM = it.variant_id === V.masseur;
      var isE = it.variant_id === V.ebook;
      var name = isStrap ? T.strap : isM ? T.gift_masseur : isE ? T.gift_ebook : it.product_title;
      var src = isM && T.img_m ? T.img_m : isE && T.img_e ? T.img_e : (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '');
      var img = src ? '<img src="' + esc(src) + '" width="64" height="64" alt="" loading="lazy">' : (isM ? ICON_HEAT : isE ? ICON_BOOK : '');
      var orig = it.original_line_price;
      var fin = it.final_line_price;
      var worth = Math.max(orig, (isM ? (T.mv || 0) : isE ? (T.ev || 0) : 0) * it.quantity);
      var price = fin === 0 && (isM || isE)
        ? (worth > 0 ? '<s>' + esc(money(worth, cur)) + '</s>' : '') + '<b class="is-free">' + esc(T.free) + '</b>'
        : (orig > fin ? '<s>' + esc(money(orig, cur)) + '</s>' : '') + '<b>' + esc(money(fin, cur)) + '</b>';
      var mid = isStrap
        ? '<div class="kz-qty" role="group" aria-label="' + esc(T.qty) + '"><button type="button" data-kz-dec="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="' + esc(T.minus) + '">−</button><span>' + it.quantity + '</span><button type="button" data-kz-inc="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="' + esc(T.plus) + '">+</button></div>'
        : (isM || isE ? '' : '<p class="kz-line__gift">× ' + it.quantity + '</p>');
      if (!(isM || isE)) mid += '<button type="button" class="kz-line__rm" data-kz-rm="' + esc(it.key) + '" aria-label="' + esc((T.remove || 'Retirer') + ' ' + name) + '">' + ICON_TRASH + '<span>' + esc(T.remove || 'Retirer') + '</span></button>';
      return '<div class="kz-line"><span class="kz-line__img">' + img + '</span><div><p class="kz-line__name">' + esc(name) + '</p>' + mid + '</div><div class="kz-line__price">' + price + '</div></div>';
    }).join('');
    var straps = qtyOf(cart, V.strap);
    upsell.hidden = !(straps > 0 && straps < 4);
    if (!upsell.hidden) {
      var paid = 0;
      items.forEach(function (it) { if (it.variant_id === V.strap) paid += it.final_line_price; });
      var more = 4 - straps;
      var diff = Math.max(0, (T.pack || 5990) - paid);
      var ut = $('[data-kz-upsell-txt]', upsell);
      if (ut) ut.textContent = String(T.upsell || '').replace('{n}', more === 1 ? T.unit1 : String(T.unitn || '').replace('{n}', more)).replace('{p}', money(diff, cur));
    }
    var ship = $('[data-kz-ship]', drawer);
    var free = cart.total_price >= (D.free || 3985);
    ship.textContent = free ? T.ship_free : T.ship_paid;
    ship.classList.toggle('is-free', free);
    var save = $('[data-kz-save]', drawer);
    var saved = (cart.original_total_price || 0) - cart.total_price;
    items.forEach(function (it) {
      var isM = it.variant_id === V.masseur, isE = it.variant_id === V.ebook;
      if ((isM || isE) && it.final_line_price === 0) saved += Math.max(0, (isM ? (T.mv || 0) : (T.ev || 0)) * it.quantity - it.original_line_price);
    });
    if (saved > 0) { save.hidden = false; save.textContent = T.savings + ' ' + money(saved, cur); } else { save.hidden = true; }
    $('[data-kz-total]', drawer).textContent = money(cart.total_price, cur);
  }

  var busy = false;
  function lock(on) {
    busy = on;
    $$('[data-kz-submit],[data-kz-sticky-buy],[data-kz-upgrade]').forEach(function (b) { b.setAttribute('aria-busy', on ? 'true' : 'false'); b.disabled = on; });
    if (drawer) drawer.setAttribute('data-busy', on ? '1' : '0');
  }

  function changeLine(key, q) {
    if (busy) return;
    lock(true);
    req('cart/change.js', { id: key, quantity: q }).then(normalize).then(function (c) { cartState = c; render(c); })
      .catch(function () { return refresh(); }).then(function () { lock(false); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kz-close],[data-kz-close-go],[data-kz-dec],[data-kz-inc],[data-kz-rm],[data-kz-upgrade]');
      if (!t) return;
      if (t.hasAttribute('data-kz-close')) { closeDrawer(); return; }
      if (t.hasAttribute('data-kz-close-go')) { var h = t.getAttribute('href') || ''; if (h.charAt(0) === '#') { e.preventDefault(); closeDrawer(); goOffer(); } return; }
      if (t.hasAttribute('data-kz-dec')) { changeLine(t.getAttribute('data-kz-dec'), Math.max(0, +t.getAttribute('data-q') - 1)); return; }
      if (t.hasAttribute('data-kz-rm')) { changeLine(t.getAttribute('data-kz-rm'), 0); return; }
      if (t.hasAttribute('data-kz-inc')) { changeLine(t.getAttribute('data-kz-inc'), +t.getAttribute('data-q') + 1); return; }
      if (t.hasAttribute('data-kz-upgrade')) {
        if (busy) return;
        lock(true);
        var u = {}; u[V.strap] = 4; if (V.ebook) u[V.ebook] = 1; if (V.masseur) u[V.masseur] = 1;
        req('cart/update.js', { updates: u }).then(normalize).then(function (c) { cartState = c; render(c); })
          .catch(function () { return refresh(); }).then(function () { lock(false); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  $$('[data-kz-cart-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(); refresh().catch(function () {}); }); });

  var buy = $('[data-kz-buy]');
  var form = $('[data-kz-form]');

  function selected() {
    var r = form ? $('input[name="kz_tier"]:checked', form) : null;
    return r;
  }

  function syncTier() {
    var r = selected();
    if (!r) return;
    var q = +r.value;
    $$('.kz-tier').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
    if (buy) buy.setAttribute('data-tier', q);
    $$('[data-kz-gift-min]').forEach(function (g) { g.classList.toggle('is-off', q < +g.getAttribute('data-kz-gift-min')); });
    $$('[data-kz-sel-name]').forEach(function (el) { el.textContent = r.getAttribute('data-name'); });
    $$('[data-kz-sel-price]').forEach(function (el) { el.textContent = r.getAttribute('data-price'); });
    $$('[data-kz-sel-compare]').forEach(function (el) { el.textContent = r.getAttribute('data-compare'); });
    $$('[data-kz-sel-off]').forEach(function (el) { el.textContent = '-' + r.getAttribute('data-off') + ' %'; });
    $$('[data-kz-cta-price]').forEach(function (el) { el.textContent = r.getAttribute('data-price'); });
  }

  function goOffer() {
    var target = $('.kz-tiers') || $('#kz-offer');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (form) {
    form.addEventListener('change', function (e) { if (e.target && e.target.name === 'kz_tier') syncTier(); });
    syncTier();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || form.getAttribute('data-busy') === '1') return;
      var r = selected();
      if (!r || !V.strap) return;
      var n = +r.value;
      var err = $('[data-kz-error]', form);
      if (err) err.hidden = true;
      form.setAttribute('data-busy', '1');
      lock(true);
      var have = cartState || { items: [] };
      var straps = qtyOf(have, V.strap) + n;
      var want = wantedGifts(straps);
      var items = [{ id: V.strap, quantity: n }];
      if (V.ebook && want.ebook && !qtyOf(have, V.ebook)) items.push({ id: V.ebook, quantity: 1 });
      if (V.masseur && want.masseur && !qtyOf(have, V.masseur)) items.push({ id: V.masseur, quantity: 1 });
      req('cart/add.js', { items: items })
        .then(function () { return req('cart.js'); })
        .then(normalize)
        .then(function (c) { cartState = c; render(c); openDrawer(); })
        .catch(function () { if (err) err.hidden = false; return refresh().catch(function () {}); })
        .then(function () { form.removeAttribute('data-busy'); lock(false); });
    });
  }

  $$('[data-kz-sticky-buy]').forEach(function (b) {
    b.addEventListener('click', function () { if (form && !busy) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); } });
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#kz-offer"]');
    if (!a || !form) return;
    e.preventDefault();
    var pick = a.getAttribute('data-kz-pick');
    if (pick) { var r = $('input[name="kz_tier"][value="' + pick + '"]', form); if (r) { r.checked = true; syncTier(); } }
    goOffer();
  });

  var sticky = $('[data-kz-sticky]');
  var anchor = $('#kz-buy-cta');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var tiersBox = $('.kz-tiers');
    var visible = { cta: false, tiers: false };
    var setSticky = function () {
      var on = !visible.cta && !visible.tiers && !(drawer && !drawer.hidden);
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('a,button', sticky).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      document.body.classList.toggle('kz-has-sticky', on);
    };
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.target === anchor) visible.cta = en.isIntersecting; else visible.tiers = en.isIntersecting; });
      setSticky();
    }, { threshold: 0 });
    io.observe(anchor);
    if (tiersBox) io.observe(tiersBox);
  }

  var addBiz = function (d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
  $$('[data-kz-eta]').forEach(function (eta) {
    try {
      var now = new Date();
      var loc = eta.getAttribute('data-locale') || 'fr-FR';
      var f = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long' });
      var d1 = addBiz(now, 4), d2 = addBiz(now, 7);
      var fa = d1.getMonth() === d2.getMonth() ? new Intl.DateTimeFormat(loc, { day: 'numeric' }).format(d1) : f.format(d1);
      var txt = (eta.getAttribute('data-tpl') || '').replace('{a}', fa).replace('{b}', f.format(d2));
      if (loc.slice(0, 2) === 'it') txt = txt.replace(/ il (8|11)\b/g, " l'$1");
      $('[data-kz-eta-text]', eta).textContent = txt;
      eta.hidden = false;
    } catch (e) {}
  });

  $$('[data-kz-gallery]').forEach(function (g) {
    var track = $('[data-kz-track]', g);
    var thumbs = $$('[data-kz-thumb]', g);
    var counter = $('[data-kz-count-slide]', g);
    var cap = $('[data-kz-cap]', g);
    var slides = $$('.kz-slide', track);
    if (!track || !slides.length) return;
    var idx = 0;
    var seen = false;
    var gv = $$('[data-kz-gvideo]', g);
    var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var primeG = function () { gv.forEach(function (v) { if (!v.getAttribute('poster') && v.getAttribute('data-poster')) v.setAttribute('poster', v.getAttribute('data-poster')); }); };
    var syncVid = function () {
      gv.forEach(function (v) {
        var on = seen && slides[idx] && slides[idx].contains(v);
        if (on) { primeG(); if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src'); if (calm) { v.controls = true; return; } var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    };
    if (gv.length) {
      if (document.readyState === 'complete') setTimeout(primeG, 1200); else window.addEventListener('load', function () { setTimeout(primeG, 1200); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (ents) { ents.forEach(function (en) { seen = en.isIntersecting; syncVid(); }); }, { threshold: 0.35 }).observe(track);
      } else { seen = true; }
    }
    var go = function (i) { idx = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' }); };
    var mark = function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      idx = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (cap && slides[i] && slides[i].getAttribute('data-cap')) cap.textContent = slides[i].getAttribute('data-cap');
      g.classList.toggle('is-vid', !!(slides[i] && slides[i].querySelector('video')));
      syncVid();
      var th = thumbs[i];
      if (th && th.parentNode) { var p = th.parentNode; var l = th.offsetLeft - p.clientWidth / 2 + th.clientWidth / 2; p.scrollTo({ left: l, behavior: 'smooth' }); }
    };
    var tm;
    track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(mark, 60); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-kz-thumb')); }); });
    var prev = $('[data-kz-prev]', g); var next = $('[data-kz-next]', g);
    if (prev) prev.addEventListener('click', function () { go(idx - 1 < 0 ? slides.length - 1 : idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1 >= slides.length ? 0 : idx + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(idx + 1); if (e.key === 'ArrowLeft') go(idx - 1); });
  });

  var vids = $$('[data-kz-video]');
  if (vids.length) {
    var prime = function (v) { if (!v.getAttribute('poster') && v.getAttribute('data-poster')) v.setAttribute('poster', v.getAttribute('data-poster')); };
    var start = function (v) { prime(v); if (!v.getAttribute('src') && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); } var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) start(en.target); else if (!en.target.paused) en.target.pause(); }); }, { rootMargin: '200px 0px' });
      vids.forEach(function (v) { vio.observe(v); });
      var pio = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { prime(en.target); pio.unobserve(en.target); } }); }, { rootMargin: '900px 0px' });
      vids.forEach(function (v) { pio.observe(v); });
    } else { vids.forEach(start); }
  }

  $$('[data-kz-more-btn]').forEach(function (b) {
    b.addEventListener('click', function () { $$('[data-kz-more]').forEach(function (r) { r.hidden = false; }); b.hidden = true; });
  });

  var loc = $('[data-kz-loc]');
  if (loc) loc.addEventListener('change', function () { if (loc.form) loc.form.submit(); });

  refresh().catch(function () {});
})();
